import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { PmaxPreviewData } from '../../../../../../../models/google-template/preview-interfaces/pmax-preview-data.interface';
import { CreativeFormat, CreativeImageRouterHelper } from '../../../../../../../utils/creative-image-router-helper';
import { DiscoverMobileHeaderComponent } from '../../../preview-common/discover/discover-mobile-header/discover-mobile-header.component';
import { MobileFrameComponent } from '../../../preview-common/mobile-frame/mobile-frame.component';

/** Performance Max in the Google Discover feed (mobile): square image card. */
@Component({
    selector: 'app-pmax-discover-square-mobile',
    imports: [CommonModule, MobileFrameComponent, DiscoverMobileHeaderComponent],
    templateUrl: './discover-square-mobile.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: [
        '../../../preview-common/discover/discover-mobile-styles.scss',
        './discover-square-mobile.component.scss',
    ]
})
export class PmaxDiscoverSquareMobilePreviewComponent {
  @Input() data!: PmaxPreviewData;

  /** This placement's creative slot is the 1:1 square format. */
  readonly creativeFormat: CreativeFormat = 'square';

  /** Shown in place of the creative when the matching upload is missing. */
  readonly missingDimensionLabel = CreativeImageRouterHelper.labelFor(this.creativeFormat);

  /** The uploaded creative matching {@link creativeFormat}, if any. */
  get creativeImage(): string {
    return CreativeImageRouterHelper.resolve(this.data.images ?? [], this.creativeFormat);
  }
}
